import * as angular from 'angular';

const envCopy: any = {};
(<any>Object).assign(envCopy, (<any>window).env);
const GLOBAL_AUTH_TOKEN = envCopy.globalAuthorizationToken;
const AUTH_URI = envCopy.auth;
const SERVICE_URI = envCopy.services;
const SERVICE_CLOUD = envCopy.cloud;
const PAYMENT_COMPONENT_URI = envCopy.paymentsComponent;

const subscriptionModelsAppConstant = {
    lang: 'es',
    market: 'ES',
    timeWait: 2000,
    numAttemps: 3,
    servicesURI: SERVICE_URI,
    env: envCopy,
    LABELS_ROUTE: '/iberia-web-content/literales/baggage-calculator/',
    defaultBackgroundImageWidth: 'generico/disponibilidad_default_',
    defaultBackgroundImage: 'generico/disponibilidad_default_2000.jpg',
    backgroundImagesBaseRoute: '/background/',
    //app Routes
    i18nRoute: '/iberia-web-content/literales/subscription-models/',
    generalI18nRoute: '/iberia-web-content/literales/general/',
    iconsRoute: '/iberia-web-content/iconos',
    localeRoute: '/iberia-web-content/locales',
    imagesRoute: '/iberia-web-content/imagenes',
    linksRoute: '/iberia-web-content/links/baggage-calculator',
    templatesRoute: 'web-subscription-models/templates/',
    componentModalRoute: 'web-subscription-models/templates/',
    availableLanguages: ['en', 'es', 'ls', 'zh', 'ca', 'de', 'fr', 'it', 'pt', 'ja', 'nl', 'ru'],
    defaultLang: 'es',
    defaultMarket: 'ES',
    appName: 'plan ahorro',
    QUADRIGAMS: {
        PLAPAX: 'PLAPAX',
        GIFTCARDS_PAYMENT: 'PLPURC',
        STEPS: {
            CONFIGURACION:'configuracion',
            PAGO: 'pago',
            CONFIRMACION: 'confirmacion'
        }
    },
    DATALAYER_EVENT_TYPES: {
        VIEW: 'view'
    },
    TYPE_CITY: {
        DESTINY: 'destiny',
        ORIGIN: 'origin'
    },
    COOKIES: {
        PERSONALIZATION: 'IBERIACOM_PERSONALIZATION',
        LOGGED_TOKEN: 'IBERIACOM_SSO_ACCESS',
        LOGGED_TOKEN_EXPIRATION: 'IBERIACOM_SSO_ACCESS_TO',
        LOGGED_REFRESH_TOKEN: 'IBERIACOM_SSO_REFRESH',
        LOGGED_REFRESH_TOKEN_EXPIRATION: 'IBERIACOM_SSO_REFRESH_TO',
        DEFAULT_EXPIRY_TIME: 1000 * 60 * 60 * 24 * 365 * 10, //ten years
        DEFAULT_PATH: '/'
    },
    nameParameters: {
        lang: 'language',
        market: 'market',
        paymentStatus: 'paymentStatus',
        componentType: 'componentType'
    },
    STEPS: {
        PAGOS: 'ibpurc',
        HOME: 'home',
        CONFIRMATION: 'confirmation',
        STEPS: 'SUBSCRIPTIONMODELS_STEPS'
    },
    WCS: {
        PHONE_TYPES: {
            SALES: 'RESERVAS',
            IBHOLIDAYS: 'ATTBAH'
        }
    },
    DEFAULT_ENDPOINTS: {
        AVAILABILITY: `${SERVICE_CLOUD}/v1/voucher/availability`,
        SUBSCRIPTIONMODELS: `${SERVICE_CLOUD}/v1/voucher/{flowId}/management`,
        customerDataURI: `${SERVICE_URI}/cust-cust/rs/v1/customer/complete`,
        CONDITIONS: `${SERVICE_URI}/orm-ors/rs/v1/giftcard/campaigns/conditions`,
        ORIGINS: `${SERVICE_CLOUD}/v1/voucher/origins?`,
        DESTINATIONS: `${SERVICE_CLOUD}/v1/voucher/destinations/{fromOrigin}?`,
        PAYMENT_CONTEXT:`${SERVICE_CLOUD}/v1/payment/payment-context/{flowId}`,
        PAYMENT_COMPONENT_URI: PAYMENT_COMPONENT_URI,
        SUMMARY: `${SERVICE_CLOUD}/v1/voucher/{flowId}/summary`
    },
    PATTERNS: {
        NAME_SURNAME_PATTERN: /^[a-zA-Z \-.'àÀáÁâÂãÃäÄåÅæÆçÇèÈéÉêÊëËìÌíÍîÎïÏðÐñÑòÒóÓôÔöÖøØùÙúÚûÛüÜýÝþÞÿŸßčČćĆšŠžŽđĐŁłÕõŻżŚśŔŕĚěŘřŃńŇňŹź]+$/,
        NAME_SURNAME_CLEANER:'[0-9*¡!?¿<>\ºª|/·@#$%&,:`;=?¿())_+{}\[\]\^€£¨¬~]',
        EMAIL_PATTERN: '[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}',
        EMAIL_CLEANER: '\\s+',
        PHONE_PATTERN: /^\d{8,}$/,
        PHONE_CLEANER: '\\D+',
        CVV_PATTERN: /^\d+$/,
        CVV_CLEANER: '\\D+',
        CREDIT_CARD_NUMBER_PATTERN: /^\d+$/,
        CREDIT_CARD_NUMBER_CLEANER: '\\D+',
        CARD_NUMBER_PATTERN: /^\d+$/,
        CARD_NUMBER_CLEANER: '\\D+',
        DOCS_PATTERN: /^(?!.*[¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\[\]"^€£])/,
        DOCS_CLEANER: '[¡!?¿<>\\ºª|/·@#$%&,;=?¿())_+{}\\[\\]"\\^€$£]',
        REDRESS_NUMBER_PATTERN: /^[a-zA-Z0-9\s]+$/,
        REDRESS_NUMBER_CLEANER: '[^a-zA-Z0-9\\s]',
        ERROR_RESIDENT_PATTERN: /residentDiscountInfo.residentCertificateNumber/,
        ERROR_CONGRESSMAN_PATTERN: /idInfo/,
        ERROR_FIRST_SURNAME: /firstSurname/,
        ERROR_FREQ_FLYER: /ffInfo.number/,
        AWS_WARNING_ERRORS: /AWS/,
        CONGRESSNAB_PATTERN: '[0-9]{1,12}',
        ADDITIONAL_FIELD_PATTERN: /^(?!.*[¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\[\]"^€£])/,
        ADDITIONAL_FIELD_CLEANER: '[¡!?¿<>\\ºª|/·@#$%&,;=?¿())_+{}\\[\\]"\\^€£]',
        STREET_PATTERN: /(?!.*[0-9{8,}*$¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\[\]"^€£])/,
        STREET_CLEANER: '[0-9{8,}*$¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\\[\\]"\\^€£]',
        CITY_PATTERN: /(?!.*[0-9*¡!?¿<>\\ºª|/·@#$%&,;=()_+{}\[\]"^€£])/,
        CITY_CLEANER: '[0-9*¡!?¿<>\\ºª|/·@#$%&,;=?¿())_+{}\\[\\]"\\^€$£]',
        RUC_DOCUMENT: /^([0-9]){11}$/,
        RUC_CLEANER: '\\D+',
        CDI_DOCUMENT: /^([0-9]){0,11}$/,
        ONBUSINESS_NUMBER_PATTERN: '\\d',
        AA_CARD_PATTERN: /[a-zA-Z0-9]/,
        AA_CARD_CLEANER: '[^a-zA-Z0-9]',
        DNI_DOCUMENT: /^([0-9]{8})[A-Za-z]$/m,
        PRICE_INTEGER: /^([0-9])*$/
    },
    MAX_FIELD_LENGTH: {
        MAX_LENGTH_REDRESSNUMBER: 15,
        MAX_LENGTH_NAME: 30,
        MAX_LENGTH_SURNAME: 30,
        MAX_LENGTH_FIRST_SURNAME: 39,
        MAX_LENGTH_LAST_SURNAME: 19,
        MAX_LENGTH_IBERIA_CARD: 8,
        MAX_LENGTH_OTHER_FREQUENTFLYER_CARD: 20,
        MAX_LENGTH_DNI: 9,
        MAX_LENGTH_MANDATORY_DOC: 20,
        MAX_LENGTH_ZIP_CODE: 10,
        MAX_LENGTH_PIN: 6,
        MAX_LENGTH_ADDITIONAL_FIELD: 30,
        MAX_LENGTH_MANDATORY_DOC_RUC: 11,
        MAX_LENGTH_EMAIL: 60
    },
    LANDING_URL: {
        ES: '/plan-ahorro/',
        EN: '/plan-ahorro_en/',
        CA: '/plan-ahorro_ca/',
        DE: '/plan-ahorro_de/',
        FR: '/plan-ahorro_fr/',
        IT: '/plan-ahorro_it/',
        NL: '/nl/plan-ahorro/',
        PT: '/plan-ahorro_pt/',
        RU: '/ru/plan-ahorro/',
        JA: '/ja/plan-ahorro/',
        ZH: '/zh/plan-ahorro/'
    },
    AVAILABLE_MARKETS: {
        ES: 'ES',
        EN: 'EN',
        CA: 'CA',
        DE: 'DE',
        FR: 'FR',
        IT: 'IT',
        NL: 'NL',
        PT: 'PT',
        RU: 'RU',
        JA: 'JA',
        ZH: 'ZH'
    },
    PAGES_ROUTES: {
        PAYMENTS: '/PLPURC',
        NEW_PAYMENTS: '/PLPURCO',
        CONFIRMATION: '/PLBKCFO'

    },
    FLOWAPP: 'SUBSCRIPTIONMODELS',
    SHORT_FLOWAPP: 'SM',
    TYPE: 'SUBSCRIPTION',
    PAYMENTS: {
        PAYMENTSTATUSOK: 'OK',
        PAYMENTSTATUSKO: 'KO'
    },
    GIFT_CARDS_BACK: 'GIFT_CARDS_BACK',
    SESSION_STORAGE: {
        IS_NEW_PAYMENT: 'isNewPayment',
        CONFIGURATION_INFO: 'subscriptionModelsConfigurationInfo',
        PAYMENT_CONTEXT_RESPONSE: 'subscriptionModelspaymentContextResponse',
        SUMMARY: 'subscriptionModelsSummary'
    }

};

try {
    angular.module('ib-subscription-models-app').constant('SubscriptionModelsAppConstants', subscriptionModelsAppConstant);
} catch (error) {
    angular.module('ib-subscription-models-app', []).constant('SubscriptionModelsAppConstants', subscriptionModelsAppConstant);

}

export { subscriptionModelsAppConstant };
